import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { getCurrentLanguage } from '../core/helpers/utils';
import { arbitroTranslations } from './translations-arbitro';
import { generalTranslations } from '../core/helpers/translations';
import { NotificationsService } from '../core/service/notifications.service';

// services
import { EventService } from 'src/app/core/service/event.service';
import { ArbitrosService } from './arbitros.service';

// constants
import { EventType } from 'src/app/core/constants/events';

// types
import { SortEvent } from 'src/app/shared/advanced-table/sortable.directive';
import { Column } from 'src/app/shared/advanced-table/advanced-table.component';
import { Arbitro } from './arbitros.model';

// data
import { ARBITROS } from './data';

import { Router } from '@angular/router';

@Component({
  selector: 'app-list-arbitros',
  templateUrl: './list-arbitros.component.html',
  styleUrls: ['./list-arbitros.component.scss']
})
export class ListArbitrosComponent implements OnInit {

  constructor(
    private eventService: EventService,
    private router: Router,
    private elRef: ElementRef,
    private arbitrosService: ArbitrosService,
    private notificationService: NotificationsService) { }

  records: Arbitro[] = [];
  columns: Column[] = [];
  pageSizeOptions: number[] = [10, 25, 50, 100];

  // Botón de acción de la tabla
  buttonTitle: string = '';
  buttonLink: string = '';

  // Control de loading de la tabla cuando los usuarios hayan sido recibidos desde el backend
  loaded: boolean = false;

  // Control de errores
  error: string = '';

  // Para controlar las búsquedas
  allDatasearch: Arbitro[] = []

  showConfirmDeleteModal: boolean = false;
  arbitroToDelete: Arbitro | null = null;
  showConfirmEstadoModal: boolean = false;
  arbitroToEstado: Arbitro | null = null;
  estadoAction: 'ACTIVAR' | 'DESACTIVAR' | null = null;

  ngAfterViewInit(): void {

  }


  ngOnInit(): void {
    let currentLanguage: string = getCurrentLanguage()
    const currentTranslations = generalTranslations[currentLanguage].TABLE;
    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
      {
        title: currentTranslations.ARBITROS,
        breadCrumbItems: [{ label: currentTranslations.ARBITROS, path: '.', active: true }]
      }
    );
    this._fetchData();

  }

  /**
 * fetches table records
 */
  _fetchData(): void {

    this.arbitrosService.getArbitros().subscribe((resArbitros) => {
      this.records = resArbitros;
      //console.log("resArbitros",resArbitros)

      // Convierto las nacionalidades
      this.arbitrosService.getNacionalidades().subscribe(resNacionalidades => {

        // Procesamiento datos para Nacionalidades
        const dataNacionalidadesFromDB = resNacionalidades;
        const convertedNacionalidadesData = dataNacionalidadesFromDB.map(item => ({
          value: item.codigo_alfa2,
          label: item.es
        }));

        // Actualizar las nacionalidades en los registros de árbitros
        this.records = this.records.map(arbitro => {
          const nuevasNacionalidades = arbitro.nacionalidades?.map(codigo => {
            const correspondencia = convertedNacionalidadesData.find(item => item.value === codigo);
            return correspondencia ? " "+correspondencia.label : codigo; // Devuelve el label si existe, si no, devuelve el código. Añade un espacio delante de la coma
          })
          return { ...arbitro, nacionalidades: nuevasNacionalidades }; // Crea un nuevo objeto de árbitro con las nacionalidades actualizadas
        });


        this.allDatasearch = this.records; // Guardo una copia de todos los datos para la búsqueda
        this.initTableCofig();
        this.loaded = true;

      })



    },
      (error: string) => {
        this.error = error;
        //console.error(error)
        this.loaded = false;
      });

    //this.records = ARBITROS;
    //this.loaded = true;
  }

  /**
   * initialize advanced table columns
   */
  initTableCofig(): void {
    let currentLanguage: string = getCurrentLanguage()
    const currentTranslations = arbitroTranslations[currentLanguage].TABLE;
    this.columns = [
      {
        name: 'nombre',
        label: currentTranslations.NAME,
        formatter: (record: Arbitro) => record.nombre,
        width: 245,
      },
      {
        name: 'apellidos',
        label: currentTranslations.LAST_NAME,
        formatter: (record: Arbitro) => record.apellidos,
        width: 360,
      },
      {
        name: 'validado',
        label: currentTranslations.VALIDADO,
        formatter: (record: Arbitro) => record.validado,
        sort: false,
        width: 30,
      },
      {
        name: 'activo',
        label: currentTranslations.ACTIVO,
        formatter: (record: Arbitro) => record.activo,
        sort: false,
        width: 30,
      },
      {
        name: 'nacionalidad',
        label: currentTranslations.NATIONALITY,
        formatter: (record: Arbitro) => record.nacionalidades,
        sort: false,
        width: 360,
      },
      {
        name: 'accionesArbitros',
        label: currentTranslations.ACTIONS,
        formatter: (record: Arbitro) => null, // No necesito enviar nada porque advanced table ya trata la columna tipo acciones
        //formatter: (record: Arbitro) => "<i class='fe-edit editClickable_" + record.id + "'></i><i class='fe-trash-2 deleteClickable_" + record.id + "'></i>",
        width: 360,
        sort: false
      }
    ];
  }


  // compares two cell values
  compare(v1: string | number, v2: string | number): any {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  /**
   * Sort the table data
   * @param event column name, sort direction
   */
  onSort(event: SortEvent): void {
    if (event.direction === '') {
      this.records = this.allDatasearch;
    } else {
      this.records = [...this.records].sort((a, b) => {
        const res = this.compare(a[event.column] as string | number, b[event.column] as string | number);
        return event.direction === 'asc' ? res : -res;
      });
    }
  }

  /**
* Recibe un texto y lo normaliza a lowercase y quita tildes para poder hacer búsquuedas
* @param text Texto a normalizar
*/
  normalizeText(text: string): string {

    return text.trim().toLocaleLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Normaliza letras con tilde
  }


  /**
 * Match table data with search input
 * @param row Table row
 * @param term Search the value
 */
  matches(row: Arbitro, term: string) {

    // Aplicar la lógica de búsqueda
    return this.normalizeText(row.nombre as string).includes(this.normalizeText(term))
      || this.normalizeText(row.apellidos as string).includes(this.normalizeText(term));
  }


  /**
   * Search Method
  */
  searchData(searchTerm: string): void {
    if (searchTerm === '') {
      this.records = this.allDatasearch;
    }
    else {
      let updatedData = this.allDatasearch;

      //  filter
      updatedData = updatedData.filter(record => this.matches(record, searchTerm));
      //console.log("updatedData ->",updatedData)
      this.records = updatedData;
    }

  }

  openDeleteModal(arbitro: Arbitro) {
    this.arbitroToDelete = arbitro;
    this.showConfirmDeleteModal = true;
  }

  closeDeleteModal() {
    this.showConfirmDeleteModal = false;
    this.arbitroToDelete = null;
  }

  confirmDelete() {
    if (this.arbitroToDelete?.id) {
      this.arbitrosService.deleteArbitro(this.arbitroToDelete.id).subscribe(() => {
        const deleteArbitroListSuccessMessage: string = $localize`:@@deleteArbitroListSuccessMessage:Árbitro borrado correctamente`;
        this.notificationService.showSuccessNotification(deleteArbitroListSuccessMessage);
        this._fetchData();
        this.closeDeleteModal();
      });
    }
  }

  openEstadoModal(arbitro: Arbitro) {
    this.arbitroToEstado = arbitro;
    this.estadoAction = arbitro.activo === true ? 'DESACTIVAR' : 'ACTIVAR';
    this.showConfirmEstadoModal = true;
  }

  closeEstadoModal() {
    this.showConfirmEstadoModal = false;
    this.arbitroToEstado = null;
    this.estadoAction = null;
  }

  confirmEstado() {
    if (this.arbitroToEstado?.id && this.estadoAction) {
      this.arbitrosService.updateArbitroEstado(this.arbitroToEstado.id, this.estadoAction).subscribe(() => {
        const shouldBeActive = this.estadoAction === 'ACTIVAR';
        this.records = this.records.map((record) =>
          record.id === this.arbitroToEstado?.id ? { ...record, activo: shouldBeActive } : record
        );
        this.allDatasearch = this.allDatasearch.map((record) =>
          record.id === this.arbitroToEstado?.id ? { ...record, activo: shouldBeActive } : record
        );
        const estadoSuccessMessage: string = this.estadoAction === 'ACTIVAR'
          ? $localize`:@@activarUsuarioSuccessMessage:Usuario activado correctamente`
          : $localize`:@@desactivarUsuarioSuccessMessage:Usuario desactivado correctamente`;
        this.notificationService.showSuccessNotification(estadoSuccessMessage);
        this.closeEstadoModal();
      });
    }
  }



}
